import React from "react";
import './index.css'

const WeatherImg = (props) => {
  const { link } = props;
  return (
    <img
      className="logo"
      src={link}
      alt="logo"
    />
  );
};

export default WeatherImg;
